var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Terms & Conditions")]),_c('div',{staticClass:"mt-5"})])
}]

export { render, staticRenderFns }